import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { Convert } from '@app/shared/utils/ConvertMimeTypes';
import Utils from '@app/shared/utils/utils';
import { ScreeningStateModel } from '@app/store/screening';
import { ScreeningService } from '@app/store/screening/screening.service';
import { ScreeningState } from '@app/store/screening/screening.state';
import { AddTask } from '@app/store/tasks/tasks.actions';
import { Store } from '@ngxs/store';
import { ToastrService } from 'ngx-toastr';
import { tap } from 'rxjs';

declare const MediaRecorder: any;
interface IRecord {
  data: Blob;
}

enum RecSteps {
  INIT_REC = 'Iniciar Gravação',
  STOP_CONTINUE = 'Finalizar Gravação e Continuar',
  RETRY = 'Enviar Novamente a Gravação',
}

@Component({
  selector: 'app-recording',
  templateUrl: './recording.component.html',
  styleUrls: ['./_recording.component.sass'],
})
export class RecordingComponent implements OnInit {
  @Input() private nextStep: any;
  @ViewChild('video') private videoDisplay: any;
  @Output() completedChange = new EventEmitter<boolean>();

  private blobRec: Blob;
  private btnIsDisabled = true;
  private nameRec: string;
  private recordedChunks = [];
  private theRecorder: any;
  private theStream: MediaStream;
  private urlRec: string;
  defaultVideoMimeType = 'video/webm';
  devices: any[];
  deviceSelected: any;

  hasGenerateFile: boolean;
  tradeId: string;

  buttonControls = {
    action: Function,
    label: '',
    isRec: false,
  };

  recorder = {
    ondataavailable: {},
    start: Function(),
  };

  files: File[] = [];
  file: File;
  isManual: boolean;

  inputUpload = {
    model: '',
    label: 'Vídeo manual',
    name: 'inputUpload',
    nameButton: 'selecionar',
    value: '',
    id: 'inputUpload',
    type: 'file',
    accept: 'video/*',
  };

  time = {
    current: {
      hrs: 0,
      min: 0,
      sec: 0,
      total: '00:00:00',
    },
    store: null,
  };

  constructor(
    private _store: Store,
    private _toastrService: ToastrService,
    private _screeningService: ScreeningService
  ) {}

  ngOnInit(): void {
    const { idTrade } = this._store.selectSnapshot(ScreeningState);
    this.tradeId = idTrade;
    this.startPreviewVideo();
  }

  onChangeFiles(event) {
    const file: File = event.target.files[0];

    if (file) {
      this.file = file;
      this.files.push(file);
    }
  }

  startPreviewVideo() {
    this.getConnectedDevices('videoinput', (cameras: any[]) => {
      this.devices = cameras;
      this.deviceSelected = this.devices[0].deviceId;
      this.startVideo();
    });
  }

  getConnectedDevices(type, callback) {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      const filtered = devices.filter((device) => device.kind === type);
      callback(filtered);
    });
  }

  startVideo(): void {
    this.actionButton();
    this.completedChange.emit(true);

    const constraints = {
      video: true,
      audio: false,
      focusMode: 'auto',
    };

    const videoMedia: Promise<any> = navigator.mediaDevices.getUserMedia(constraints);

    videoMedia.then(this.gotMedia.bind(this)).catch((e) => {
      console.error('getUserMedia() failed: ' + e);
      this._toastrService.warning('Não foi possível acessar a câmera. Tente novamente!');
    });
  }

  continue(isManual = false, blobRec?: any): void {
    this.isManual = isManual;
    const [fileManual] = this.files;

    if (isManual) {
      this.nameRec = this.filenameGenerator(fileManual.type);
    } else {
      this.nameRec = this.filenameGenerator(blobRec.type);
    }

    if (this.buttonControls.label === RecSteps.STOP_CONTINUE && !isManual) {
      this.downloadVideo();
    }

    const payload: ScreeningStateModel = {
      idTrade: this.tradeId,
      screeningStep: 'gravacao',
      blobRec: blobRec?.type === 'click' ? this.file : blobRec,
      videoName: this.nameRec,
      fileType: isManual ? fileManual.type : blobRec.type,
    };
    const fullFilename = `${this.tradeId}/${payload.videoName}`;
    this._store.dispatch(
      new AddTask({
        name: payload.videoName,
        file: payload.blobRec,
        uploadPayload: payload,
        getPresignedApiUrlService: 'COLLECT.postGeneratePresignedUrl',
        preSignedRequest: {
          contentType: payload.fileType,
          filename: fullFilename,
          idTrade: this.tradeId,
        },
        updateGalleryApiUrlService: 'COLLECT.postRegisterUploadedMedia',
        updateTradeGalleryRequest: {
          idTrade: this.tradeId,
          filename: fullFilename,
        },
        successMessage: 'Upload finalizado com sucesso.',
        errorMessage: 'Não foi possível enviar a gravação. Por favor, tente novamente.',
      })
    );
    this._screeningService
      .setStatusScreening(this.tradeId, 'gravacao')
      .pipe(
        tap(() => {
          this.completedChange.emit(true);
          this.nextStep();
        })
      )
      .subscribe();
  }

  private filenameGenerator(mimeType: string) {
    return `${Utils.randomFilenameGenerator('evidencia_gravacao', Convert.getExtension(mimeType)[0])}`;
  }
  private startRecording(): void {
    if (!this.btnIsDisabled) {
      this.recorder.start(100);
      this.actionButton();
      this.completedChange.emit(false);

      this.startTime();
    }
  }

  private gotMedia(stream: MediaStream) {
    this.theStream = stream;
    this.videoDisplay.nativeElement.srcObject = stream;

    try {
      this.recorder = new MediaRecorder(stream, { mimeType: this.defaultVideoMimeType });
    } catch (e) {
      console.error('Exception while creating MediaRecorder: ' + e);
      return;
    }

    this.theRecorder = this.recorder;
    this.btnIsDisabled = false;

    this.recorder.ondataavailable = (event: IRecord) => {
      this.recordedChunks.push(event.data);
    };
  }

  private actionButton(isError = false): void {
    let { label, action } = this.buttonControls;

    if (label === '') {
      label = RecSteps.INIT_REC;
      action = this.startRecording.bind(this);
    } else if (label === RecSteps.INIT_REC) {
      label = RecSteps.STOP_CONTINUE;
      action = this.stopRecording.bind(this);
    } else if (label === RecSteps.STOP_CONTINUE && isError) {
      label = RecSteps.RETRY;
      action = this.stopRecording.bind(this);
    }

    const isRec = label === RecSteps.STOP_CONTINUE;

    this.buttonControls = {
      action,
      label,
      isRec,
    };
  }

  private stopRecording(): void {
    if (this.buttonControls.isRec) {
      this.stopCount();
      this.theRecorder.stop();
      this.theStream.getTracks().forEach((track) => {
        track.stop();
      });

      this.blobRec = new Blob(this.recordedChunks, { type: this.defaultVideoMimeType });
      this.urlRec = URL.createObjectURL(this.blobRec);

      this.actionButton();

      setTimeout(() => {
        URL.revokeObjectURL(this.urlRec);
      }, 100);
    }

    this.continue(false, this.blobRec);
  }

  private downloadVideo(): void {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.setAttribute('href', this.urlRec);
    a.setAttribute('download', this.nameRec);
    a.click();

    setTimeout(() => {
      URL.revokeObjectURL(this.urlRec);
    }, 100);
  }

  private validMinSec() {
    this.time.current.sec++;

    if (this.time.current.sec >= 60) {
      this.time.current.sec = 0;
      this.time.current.min++;

      if (this.time.current.min >= 60) {
        this.time.current.min = 0;
        this.time.current.hrs++;
      }
    }
  }

  private countTime() {
    this.validMinSec();

    const hrs = this.time.current.hrs > 9 ? this.time.current.hrs : '0' + this.time.current.hrs;
    const min = this.time.current.min > 9 ? this.time.current.min : '0' + this.time.current.min;
    const sec = this.time.current.sec > 9 ? this.time.current.sec : '0' + this.time.current.sec;

    this.time.current.total = `${hrs}:${min}:${sec}`;
  }

  private startTime() {
    this.time.store = setInterval(this.countTime.bind(this), 1000);
  }

  private stopCount() {
    clearInterval(this.time.store);
  }
}
